import React, { Component } from 'react';

import GirisForm from './GirisForm';

class App extends Component {

    constructor(props){
        super(props);

        this.state = {

        };
    }

    componentDidMount() {
        window.app = this;
        $('body').on('click', '[data-close=alert]', function() {
            $(this).closest('.alert').hide();
        });
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    };


    render() {
        return (
            <GirisForm />
        );
    }
}

export default App;